/* ==========================================================================
   GemofU: homepage "All Categories" row as a slider. All tiles sit in one
   line (6 visible on computers, about 3 on phones); every 6 seconds it
   moves on by one tile and goes back to the start after the last one.
   Shoppers can also swipe it, or use the small arrows on computers.
   Pauses while the shopper hovers over or touches it.
   ========================================================================== */
(function () {
  'use strict';
  var EVERY = 6000;

  function build(sec) {
    if (sec._gouSlide) return;
    var wrap = sec.querySelector('.grid__wrapper');
    var items = wrap ? Array.prototype.slice.call(wrap.querySelectorAll(':scope > .collection-loop__item')) : [];
    if (items.length < 2) return;
    sec._gouSlide = true;

    var box = document.createElement('div');
    box.className = 'gou-catslide';
    var track = document.createElement('div');
    track.className = 'gou-catslide__track';
    items[0].parentNode.insertBefore(box, items[0]);
    box.appendChild(track);
    items.forEach(function (it) { track.appendChild(it); });
    box.insertAdjacentHTML('beforeend',
      '<button type="button" class="gou-catslide__btn gou-catslide__btn--prev" aria-label="Previous categories"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="gou-catslide__btn gou-catslide__btn--next" aria-label="More categories"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg></button>');

    function step() {
      var first = track.firstElementChild;
      if (!first) return 0;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
      return first.getBoundingClientRect().width + gap;
    }
    function atEnd() { return track.scrollLeft + track.clientWidth >= track.scrollWidth - 4; }
    // Smooth scroll, with a plain jump as a fallback for browsers that skip it.
    function go(left) {
      var from = track.scrollLeft;
      track.scrollTo({ left: left, behavior: 'smooth' });
      setTimeout(function () { if (Math.abs(track.scrollLeft - from) < 1 && Math.abs(left - from) > 1) track.scrollLeft = left; }, 700);
    }
    function next() { go(atEnd() ? 0 : track.scrollLeft + step()); }
    function prev() { go(track.scrollLeft <= 4 ? track.scrollWidth : track.scrollLeft - step()); }
    box.querySelector('.gou-catslide__btn--next').addEventListener('click', next);
    box.querySelector('.gou-catslide__btn--prev').addEventListener('click', prev);

    var paused = false, visible = true;
    box.addEventListener('mouseenter', function () { paused = true; });
    box.addEventListener('mouseleave', function () { paused = false; });
    box.addEventListener('touchstart', function () { paused = true; setTimeout(function () { paused = false; }, 6000); }, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { visible = e[0].isIntersecting; }).observe(box);
    }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!reduce) {
      setInterval(function () {
        if (paused || !visible || document.hidden) return;
        if (track.scrollWidth <= track.clientWidth + 4) return; // everything already fits
        next();
      }, EVERY);
    }
  }

  function start() { document.querySelectorAll('.section-collection-list').forEach(build); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
